import PLACEHOLDER_IMG from "@/assets/placeholder.png";
import { IAction, IIndexData } from "@/common/interface";
import appProgress from "@/store/common/reducers/appProgress";
import appStatus from "@/store/common/reducers/appStatus";
import { combineReducers } from "redux";
import { SET_INDEX } from "../actionTypes";
import comData from "../com/reducers";

const DEFAULT_ITEM = {
  soft_id: "",
  url: PLACEHOLDER_IMG,
  icon: "",
};

const initState: IIndexData = {
  ad: [],
  banner: new Array(3).fill(DEFAULT_ITEM),
  special1: new Array(4).fill(DEFAULT_ITEM),
  soft: [
    {
      title: "热门推荐",
      data: new Array(16).fill(DEFAULT_ITEM),
    },
  ],
  top: [],
  new_top: [],
  searches: [],
  special2: new Array(4).fill(DEFAULT_ITEM),
  recent: [],
  soft_id_list: [],
};

const indexData = (state = initState, action: IAction): IIndexData => {
  switch (action.type) {
    case SET_INDEX:
      return { ...state, ...action.data };
    default:
      return state;
  }
};

export default combineReducers({
  indexData,
  appStatus,
  appProgress,
  comData,
});
